export default __webpack_public_path__ + "e5bbd5c94674ca56bd36b264897995b5.png";